import styled from '@emotion/styled'

export const Wrapper = styled('div')(() => ({}))

export const Session = styled('div')(() => ({
  width: 'auto',
  marginTop: 12,
  padding: 12,
  border: '1px solid #EDEBEB',
  borderRadius: '5px'
}))
